import { HTMLAttributes } from "react";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import { useColorMode, Text } from "@chakra-ui/react";
import { es } from 'date-fns/locale';

import '../../assets/css/datepicker.css'
import "react-datepicker/dist/react-datepicker.css";

interface IPropsDatePicker {
    onChange: (date: any) => void
    selectedDate: Date | undefined
    showPopperArrow?: boolean
    text: string
    name: string
}

const DatePicker = ({
    selectedDate,
    onChange,
    text,
    showPopperArrow = false,
    name,
    ...props
}: IPropsDatePicker & HTMLAttributes<HTMLElement>) => {
    registerLocale("es", es);
    const isLight = useColorMode().colorMode === "light";
    return (
        <div className={isLight ? "light-theme" : "dark-theme"}>
            <Text mt={2}>{text}</Text>
            <ReactDatePicker
                selected={selectedDate}
                onChange={onChange}
                showPopperArrow={showPopperArrow}
                locale="es"
                dateFormat="yyyy-MM-dd"
                name={name}
            />
        </div>
    );
};

export default DatePicker;